// Shared color theme for C&S Bid Command Center
const CL = {
  won: "#22c55e", lost: "#ef4444", active: "#3b82f6", responded: "#f59e0b",
  noBid: "#6b7280", cancelled: "#4b5563",
  bg: "#0a0e17", card: "#111827", border: "#1e293b",
  text: "#e2e8f0", dim: "#94a3b8", muted: "#64748b",
  gold: "#B3A369", crimson: "#9E1B32", navy: "#003057",
  tactical: "#22c55e", structural: "#f59e0b", margin: "#f97316", walkaway: "#ef4444",
  specialty: "#a78bfa",
};

export default CL;
